"use strict";

const merge = require("webpack-merge");
const { SERVER_URL } = require("./prod.env");
const prodEnv = require("./prod.env");

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  // SERVER_URL: '"http://localhost:3000"'
  // SERVER_URL: '"http://192.168.1.192:3000"'
  // SERVER_URL: '"https://dev.prk-pro.com"'
  SERVER_URL: '"https://prk-pro.com/api"'
});



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 687
// module chunks = 1